module.exports = __webpack_public_path__ + "static/media/tata-overhead-assembly.00569467.gif";